import * as Application from './Application';
import * as Message from './Message';
import * as Auth from './Auth';
import * as Image from './Image';
import * as Folder from './Folder';
import type { ThunkDispatch } from 'redux-thunk';
import type { Action } from 'redux';
import { useDispatch } from 'react-redux';

// The top-level state object
export interface GlobalState {
    application: Application.ApplicationState;
    message: Message.MessageState;
    auth: Auth.AuthState;
    image: Image.ImageState;
    folder: Folder.FolderState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    application: Application.reducer,
    image: Image.reducer,
    message: Message.reducer,
    auth: Auth.reducer,
    folder: Folder.reducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => GlobalState): void;
}

// Typed dispatch that understands thunk actions
export type AppDispatch = ThunkDispatch<GlobalState, undefined, Action<string>>;

// Typed useDispatch hook
export const useAppDispatch = () => useDispatch<AppDispatch>();
